/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI BMAW
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ImageGenerationStartResponse
 */
export interface ImageGenerationStartResponse {
    /**
     * 
     * @type {string}
     * @memberof ImageGenerationStartResponse
     */
    processId: string;
}

/**
 * Check if a given object implements the ImageGenerationStartResponse interface.
 */
export function instanceOfImageGenerationStartResponse(value: object): value is ImageGenerationStartResponse {
    if (!('processId' in value) || value['processId'] === undefined) return false;
    return true;
}

export function ImageGenerationStartResponseFromJSON(json: any): ImageGenerationStartResponse {
    return ImageGenerationStartResponseFromJSONTyped(json, false);
}

export function ImageGenerationStartResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImageGenerationStartResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'processId': json['processId'],
    };
}

export function ImageGenerationStartResponseToJSON(json: any): ImageGenerationStartResponse {
    return ImageGenerationStartResponseToJSONTyped(json, false);
}

export function ImageGenerationStartResponseToJSONTyped(value?: ImageGenerationStartResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'processId': value['processId'],
    };
}

